// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"d0d141e0","787":"829aa8a5"}[chunkId] + ".chunk.js";
};